export default __webpack_public_path__ + "static/media/terragrunt.ed664b8c.png";